import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VIcon,{attrs:{"size":_vm.fontSize,"color":_vm.color}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }